<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("ReturnOrder.exportDialogTitle") }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12">
          <ValidationObserver ref="observer">
            <v-row dense align="center" class="pa-1">
              <v-col cols="5" md="4">
                <ValidationProvider
                  v-slot="{ errors }"
                  name=""
                  :rules="{
                    required:true,
                  }"
                >
                  <SearcherDatetime
                    v-model="expect_time_from"
                    id="expect_time_from"
                    type="date"
                    hide-icon
                    remove-icon
                    readonly
                    :label="$t('ReturnOrder.Fields.expect_time_from')"
                    :errors="errors"
                  >
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </SearcherDatetime>
                </ValidationProvider>
              </v-col>
              <v-col cols="1" class="text-center">~</v-col>
              <v-col cols="5" md="4">
                <ValidationProvider
                  v-slot="{ errors }"
                  name=""
                  :rules="{
                    required:true,
                  }"
                >
                  <SearcherDatetime
                    v-model="expect_time_to"
                    id="expect_time_to"
                    type="date"
                    hide-icon
                    remove-icon
                    readonly
                    :errors="errors"
                  >
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </SearcherDatetime>
                </ValidationProvider>
              </v-col>
            </v-row>
          </ValidationObserver>
          <v-row dense align="center" class="mt-n6 ml-1" style="color: rgba(0, 0, 0, 0.6); font-size: 14px">{{ $t("ReturnOrder.exportDateErrorMsg") }}</v-row>
        </v-col>
      </v-row>
      <v-row dense class="mx-5">
        <v-col cols="12" sm="5">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="account_id"
              v-model="accountKeyword"
              :label="$t('ReturnOrder.Fields.account_id')"
            />
          </v-row>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="accountItems"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        v-resize="resizeHeader"
        height="340px"
        :footer-props="footerProps"
      >
        <template v-slot:header.choose>
          <v-checkbox
            class="mt-2 mb-n3"
            color="primary"
            :indeterminate="
              accounts.find((detail) => detail.choose != chooseAll)
                ? true
                : false
            "
            v-model="chooseAll"
            :true-value="1"
            :false-value="0"
          >
            <template v-slot:label>
              <span class="caption ms-n2">
                {{ $t("CRUD.chooseAll") }}
              </span>
            </template>
          </v-checkbox>
        </template>
        <template v-slot:item.choose="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-checkbox
                color="primary"
                v-model="item.choose"
                :true-value="1"
                :false-value="0"
                :disabled="item.disabled"
            >
              <template v-slot:label>
                <span class="caption ms-n2">
                  {{ $t(item.choose ? "CRUD.choosed" : "CRUD.unchoose") }}
                </span>
              </template>
            </v-checkbox>
          </div>
        </template>
      </v-data-table>
      <v-card-actions>
        <span class="caption">
          {{ $t("CRUD.chooseCount", [choosedLength, newChoosedArr.length]) }}
        </span>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            outlined
            class="elevation-1"
            @click="dialog = false"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="accent" @click="saveChoose()">
          {{ $t("CRUD.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import { ValidationObserver, ValidationProvider} from "vee-validate";
import Accounts from "@/api/accounts";
import ReturnOrders from "@/api/return_orders";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";

export default {
  name: "DialogExport",

  props: {
    value: Boolean,
    fullField: Boolean,
  },

  components: {
    ValidationObserver,
    ValidationProvider,
    SearcherDatetime,
    SearcherKeyword,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("ReturnOrder.Fields.account_id"),
          align: "start",
          sortable: false,
          value: "account_id",
        },
        {
          text: i18n.t("ReturnOrder.Fields.account_name"),
          align: "start",
          sortable: false,
          value: "account_name",
        },
        {
          text: i18n.t("ReturnOrder.Fields.enterprise_id"),
          align: "start",
          sortable: false,
          value: "enterprise_id",
        },
        {
          text: i18n.t("CRUD.chooseAll"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "choose",
        },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    accountItems() {
      //前端搜索
      return this.accounts.filter(
        (item) =>
          ((this.accountKeyword && (item.account_id.indexOf(this.accountKeyword) > -1 || item.account_name.indexOf(this.accountKeyword) > -1)) || !this.accountKeyword)

      );
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    dialog: false,
    accounts: [],
    accountKeyword: "",
    expect_time_from: "",
    expect_time_to: "",
    itemsPerPageOptions: 10,
    chooseAll: 0,
    newChoosedArr: [],
    choosedLength: 0,
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },

    //获取供应商列表
    getAccountsFromAPI() {
      let options = {};
      if (!this.fullField) {
        let fieldFilter = [
          "id",
          "account_id",
          "account_name",
          "enterprise_id",
        ];
        options = Object.assign(
            {
              fieldFilter: fieldFilter,
              // 仅筛选少许必要字段
            },
            this.options
        );
      }

      Accounts.fetchAllNoPaging(options).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.accounts = response.data.accounts.map((account) => {
                account.choose = 0;
                return account;
              });
            }
          }.bind(this)
      );
    },

    saveChoose() {
      let from = new Date(this.expect_time_from).getTime()
      let to = new Date(this.expect_time_to).getTime()
      if (from - to < -86400000) {
        this.$snackbar.error(i18n.t("ReturnOrder.exportDateErrorMsg"));
        return
      }
      if (this.newChoosedArr.length <= 0 || this.choosedLength <= 0) {
        this.$snackbar.error(i18n.t("ReturnOrder.exportChooseErrorMsg"));
        return
      }
      let data = {
        account_ids: this.newChoosedArr.map((arr) => { return arr.account_id}),
        expect_time_from: this.expect_time_from,
        expect_time_to: this.expect_time_to
      }
      ReturnOrders.exports(data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.dialog = false;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;
          this.expect_time_from = this.expect_time_to = new Date().getFullYear() + '-' + String( new Date().getMonth() + 1).padStart(2, '0') + '-' + String(new Date().getDate()).padStart(2, '0')
          this.getAccountsFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.accountKeyword = "";
          this.chooseAll = false;
          this.newChoosedArr = [];
          this.choosedLength = 0;
        }
        this.$emit("input", this.dialog);
      },
    },
    chooseAll: {
      handler() {
        this.accounts = this.accounts.map(
            function (e) {
              var item = this.accountItems.find((m) => m.id == e.id && !e.disabled);
              if (item) e.choose = this.chooseAll ? 1 : 0;
              return e;
            }.bind(this)
        );
      },
    },
    accounts: {
      deep: true,
      handler() {
        //整理新增商品
        this.newChoosedArr = [];
        this.choosedLength = 0;
        this.accounts.forEach((account) => {
          if (account.choose) {
            this.newChoosedArr.push(account);
            this.choosedLength = this.choosedLength + 1;
          }
        });
      },
    },
  },
};
</script>